module.exports = __webpack_public_path__ + "static/media/img_dog.9ada5e7e.svg";